let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("f2eMo")).then(() => parcelRequire('6Ea8e'));